import PendingClock from "@/assets/icons/PendingClock.svg";
import { CustomButton } from "@/components/ui/Buttons";

const PendingShipment = ({
  onClick,
  status,
}: {
  status: boolean;
  onClick: () => void;
}) => {
  return (
    <div className="flex gap-x- justify-between items-center rounded-lg border border-[#EEEEEE] m-3 px-6 py-4">
      <div className="flex gap-x-3 items-center">
        <div>
          <PendingClock />
        </div>
        <div className="space-y-1">
          <h5 className="text-[#ED5E00] font-semibold text-xs leading-5">
            Awaiting Product Shipment
          </h5>
          <p className="text-[#475467] text-xs leading-5">
            The product has not been shipped yet. Please send the item to the
            creator to continue the process.
          </p>
        </div>
      </div>

      {!status && (
        <div>
          <CustomButton onClick={onClick}>Upload Shipping Details</CustomButton>
        </div>
      )}
    </div>
  );
};

export default PendingShipment;
